import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatTabService {
  private tab$ = new BehaviorSubject<'chat' | 'unread' | 'archived' | 'notes' | null>(null);

  requestTab(tab: 'chat' | 'unread' | 'archived' | 'notes') {
    this.tab$.next(tab);
  }

  get tab() {
    return this.tab$.asObservable();
  }
}
